var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-8 col-md-6"},[_c('px-card',{attrs:{"title":"Sales Summary"}},[_c('div',{staticClass:"card-body sell-graph"},[_c('apexchart',{attrs:{"type":"line","height":"320","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }